import { Component, OnDestroy, OnInit } from '@angular/core';
import { JhiAlert, JhiAlertService } from 'ng-jhipster';

@Component({
    selector: 'jhi-alert',
    template: `
        <div class="alerts custom-alert" role="alert">
            <div *ngFor="let alert of alerts" [ngClass]="{\'alert.position\': true, \'toast\': alert.toast}">
                <ngb-alert *ngIf="alert && alert.type && alert.msg" [type]="alert.type" (close)="alert.close(alerts)">
                    <pre [innerHTML]="alert.msg"></pre>
                </ngb-alert>
            </div>
        </div>`
})
export class JhiAlertComponent implements OnInit, OnDestroy {
    alerts: any[]=[];

    constructor(private alertService: JhiAlertService) {}

    ngOnInit() {
        var jhiAlerts = this.alertService.get();
        if(jhiAlerts.length>0){
            var alertsSet=new Set<JhiAlert>(jhiAlerts);
            alertsSet.forEach(alert=>this.alerts.push(alert))
            console.log(this.alerts);
        }else{
            this.alerts=jhiAlerts;
        }
    }

    ngOnDestroy() {
        this.alerts = [];
    }
}
